module.exports = __webpack_public_path__ + "img/size_1_1.ca3277e3.png";